import store from '@/store';

export function root() {
  return store.getters['account/isLoggedIn']
    ? { name: 'dashboard' }
    : store.getters['account/isAuthenticated']
      ? { name: 'account-organisations' }
      : { name: 'account-login' };
}
